import { IReducerFn } from 'context/type';
import { TTabsState } from './tabs.type';

export const tabsReducer: IReducerFn<TTabsState> = (state, { type, payload }) => {
  if (type === 'tab_active_set') {
    return {
      ...state,
      activeTab: payload,
    };
  }

  return state;
};

tabsReducer.key = 'tabs';
tabsReducer.initialState = {
  activeTab: null,
};
